import {Card} from './Card'
const data = require('../../config/cards.json')['Wheat Field']

export default class WheatField extends Card {
	constructor() {
		super(data)
	}

	/**
	 * Give one coin to player
	 */
	activate() {
		this.owner.coins++
	}
}
